<template>
  <div class="admin-card bg-white p-4 p-lg-5">
    <div class="mb-4">
      <div class="text-muted small text-uppercase font-weight-bold">CMS</div>
      <h2 class="h4 font-weight-bold text-primary mb-0">Thông tin công ty</h2>
    </div>

    <b-form @submit.prevent="saveCompanyInfo">
      <div class="row">
        <div class="col-lg-8">
          <b-form-group label="Tên công ty">
            <b-form-input v-model.trim="form.companyName" required />
          </b-form-group>
          <b-form-group label="Giới thiệu">
            <b-form-textarea v-model.trim="form.description" rows="5" />
          </b-form-group>
          <b-form-group label="Địa chỉ">
            <b-form-input v-model.trim="form.address" />
          </b-form-group>
          <b-form-group label="Mã số thuế">
            <b-form-input v-model.trim="form.taxCode" />
          </b-form-group>
        </div>
        <div class="col-lg-4">
          <b-form-group label="Logo">
            <image-uploader v-model="form.logo" />
          </b-form-group>
          <b-form-group label="Số điện thoại">
            <b-form-input v-model.trim="form.phone" />
          </b-form-group>
          <b-form-group label="Email">
            <b-form-input v-model.trim="form.email" type="email" />
          </b-form-group>
          <b-form-group label="Website">
            <b-form-input v-model.trim="form.website" />
          </b-form-group>
        </div>
      </div>
      <b-button type="submit" variant="primary" pill class="px-4">Lưu thay đổi</b-button>
    </b-form>
  </div>
</template>

<script>
import { fetchAdminCompanyInfo, updateCompanyInfo } from "../../api/admin";
import { isUnauthorizedError } from "../../utils/apiErrors";
import ImageUploader from "../../components/ImageUploader.vue";

export default {
  name: "AdminCompanyInfoView",
  components: {
    ImageUploader
  },
  data: function data() {
    return {
      form: {
        companyName: "",
        logo: "",
        description: "",
        address: "",
        taxCode: "",
        phone: "",
        email: "",
        website: ""
      }
    };
  },
  created: function created() {
    this.loadCompanyInfo();
  },
  methods: {
    async loadCompanyInfo() {
      try {
        const response = await fetchAdminCompanyInfo();
        this.form = response.data;
      } catch (error) {
        if (isUnauthorizedError(error)) return;
        throw error;
      }
    },
    async saveCompanyInfo() {
      try {
        await updateCompanyInfo(this.form);
        this.$bvToast.toast("Cập nhật thông tin công ty thành công.", {
          variant: "success",
          solid: true
        });
      } catch (error) {
        if (isUnauthorizedError(error)) return;
        throw error;
      }
    }
  }
};
</script>
